import { AssetType } from '../types/asset.type';
import { IBankingDetails } from './bank.interface';
import { IInsuredAsset } from './insured.interface';
import { QuoteRequestStatusType, QuoteRequestType } from '../types/quote.type';
import { InsurerIdType } from '../types/schedule.type';
import { IAllRiskItem, IBuilding, ICaravan, IContent, IMotorcycle, ISpecifiedItem, IVehicle } from './asset.interface';
import { IPriorityRating } from './needs-analysis.interface';
import { IPersonalLiability } from './schedule.interface';
export interface IQuoteConvertResponse {
  policy_id?: string;
  effective_date?: string;
  date_of_advice?: string;
  email?: string;
  get_retries?: number;
  insurer_details?: IInsurerDetails;
  quote_id?: string;
  quote_request_id?: string;
  success?: boolean;
  user_id?: string;
  policy_number?: string;
}
export interface IInsurerDetails {
  active?: boolean;
  description?: string;
  holiday_period_cover?: boolean;
  id?: string;
  product?: string;
  product_code?: string;
  provider?: string;
  type?: string;
}
export interface IRequestResponse {
  request_response_data: IRequestResponseData;
}

export interface IRequestResponseData {
  success: boolean;
  message?: string;
  error?: string;
  data?: any;
  response_code?: number;
}

export interface IAPIQuoteConvertResponse {
  policy_number?: string;
  policy_id?: string;
  effective_date?: string;
}

export interface IQuoteCancelledResponse {
  Quotes: string;
}

export interface IQuoteErrorRepsonse {
  event: string;
  http_response: string;
  id: number;
  insurer_id: number;
  message: string;
  quote_request_id: number;
  user_id: number;
}


export interface IQuote {
  id: number;
  inception_date: any;
  modified_time: any;
  conditions?: Array<IAllConditions>
  personal_liability: any;
  personal_liability_id: any;
  policy_status: any;
  product: string;
  quote_all_risks: IInsuredAsset[];
  quote_buildings: IInsuredAsset[];
  quote_caravans: IInsuredAsset[];
  quote_contents: IInsuredAsset[];
  quote_motorcycles: IInsuredAsset[];
  quote_specified_items: IInsuredAsset[];
  quote_vehicles: IInsuredAsset[];
  quote_nr: string;
  quote_number: any;
  quote_request_id: number;
  quote_requested_time_stamp: string;
  quote_returned_time_stamp: string;
  user_id: number;
  insurer_id?: InsurerIdType;
  submit_date?: string;
  received_date?: number;
  warnings?: any;
  disclosures?: any;
  total_premium?: number;
  total_sum_insured?: string;
  commission?: number;
  all_risk_premium?: number;
  all_risk_sum_insured?: string;
  personal_liability_sum_insured?: string;
  assistance_benefits?: Array<IAssistanceBenefit>;
  excesses?: Array<IQuoteExcess>;
  excess?: Array<IQuoteExcess>;
  rating_convenience: number;
  rating_ctrl: number;
  rating_essential: number;
  rating_excess: number;
  rating_premium: number;
  broker_fee?: number;
  mandate_violations_draft?: boolean;
  holiday_period_cover?: boolean;
  recommended?: boolean;
  insurer_description?: string;
  sasria?: number;
  prorata?: Array<IProRata>;
}

export interface IProRata {
  amount: number;
  created_time: string;
  date: string;
  id: number;
  is_clubbed: boolean
  message: string;
  modified_time: string;
  quotes_id: number;
}
export interface IAssistanceBenefit {
  description: string;
  generic_description?: string;
  premium: number;
  sum_insured: number;
}

export interface IQuoteExcess {
  description: string;
  percentage: number;
  minimum_amount: number;
  maximum_amount: number;
  id: number;
}

export interface IInsurers {
  active: boolean;
  description: string;
  holiday_period_cover: boolean;
  id: string;
  insurer_id: string;
  product: string;
  product_code: string;
  provider: string;
  type: string;
  img_source: string;
}

export interface IQuoteRequest {
  cover_premium_date?: number;
  id?: number;
  type?: QuoteRequestType;
  status?: QuoteRequestStatusType;
  status_text?: string;
  effective_date?: number;
  cover_start_date?: Date;
  includes_all_risk?: boolean; // WHY MUST THIS BE A FIELD? IF ALL RISK IS MORE THAN 1 THEN OBVIOUSLY ALL RISK SHOULD BE INCLUDED
  fna?: Array<IPriorityRating>;
  quotes?: Array<IQuote>;
  needs_analysis_completed?: number;
  underwriting_questions_completed?: number;
  optionals_completed?: number;
  confirmation_completed?: number;
  accepted?: number;
  banking_details?: IBankingDetails;
  mandate_violations_draft?: boolean;
  expiry_date?: Date;
  days_remaining?: number;
  assistance_benefits_requested?: boolean;
  contents_no_claims_bonus?: boolean;
  contents_volentary_excess?: boolean;
  contents_theft_cover_excluded?: boolean;
  contents_flood_cover_excluded?: boolean;
  buildings_volentary_excess?: boolean;
  buildings_theft_cover_excluded?: boolean;
  buildings_flood_cover_excluded?: boolean;
  buildings_geysers_and_pipes?: boolean;
  buildings_emergency_home_help?: boolean;
  vehicles_car_hire?: string;
  vehicles_roadside_assitance?: string;
  vehicles_route_help?: string;
  vehicles_safely_home_service?: string;
  assets?: IQuoteAssets;
  schedule_id?: number;
  quote_request_id?: number;
}

export interface IQuoteAssets {
  vehicles?: Array<IVehicle>;
  contents?: Array<IContent>;
  buildings?: Array<IBuilding>;
  all_risks?: Array<IAllRiskItem>;
  specified_items?: Array<ISpecifiedItem>;
  motorcycles?: Array<IMotorcycle>;
  caravans?: Array<ICaravan>;
  personal_liability?: Array<IPersonalLiability>;
}

export interface IFinancialNeedAnalysis {
  status: string; // OPEN, SUBMITTED, WAITING_TO_ACCEPT, ACCEPTED, CANCELLED, KEPT
  date_created: Date;
  date_updated: Date;
  financial_needs_analysis: Object;
}

export interface ISpecialConditionAssets {
  // need to check this.
  all_risks?: ISpecialConditionClients;
  buildings?: ISpecialConditionClients;
  caravans?: ISpecialConditionClients;
  contents?: ISpecialConditionClients;
  motorcycles?: ISpecialConditionClients;
  vehicles?: ISpecialConditionClients;
}

export interface IAllConditions {
  condition_text: string;
  condition_type: string;
  created_time: string;
  id: number;
  modified_time: string;
  quotes_id: number;
  schedule_type: string;
}

export interface IEndorsementUpdateAsset {
  all_risks?: Array<number>;
  specified_items?: Array<number>;
  buildings?: Array<number>;
  caravans?: Array<number>;
  contents?: Array<number>;
  motorcycles?: Array<number>;
  vehicles?: Array<number>;
}

export interface ISpecialConditionClients {
  ABSAPLUS?: Array<string>;
  ABSAPREMIUM?: Array<string>;
  BROLINK10?: Array<string>;
  BRYTE?: Array<string>;
  KINGPRICE?: Array<string>;
  MUTUALFEDER?: Array<string>;
  PEERLESS?: Array<string>;
  SANTAM?: Array<string>;
  MIWAY?: Array<string>;
}

export interface IQuoteCompareDetails {
  name: string;
  type: AssetType 
  active: boolean;
  essentialDetails: IQuoteCompareDetailsConvenienceEssential;
  convenienceDetails: IQuoteCompareDetailsConvenienceEssential;
  special_conditions?: any;
  all_risks?: any;
  specified_items?: any;
  quoteCompareOne?:  Array<IInsuredAsset> | IPersonalLiabilityCompare;
  quoteCompareTwo?:  Array<IInsuredAsset> | IPersonalLiabilityCompare;
}

export interface IQuoteCompareDetailsConvenienceEssential {
  quote_comp_one: IQuoteCompValues;
  quote_comp_two: IQuoteCompValues;
}

export interface IQuoteCompValues {
  description?: string;
  group_items?: Array<IQuoteCompareGroupItems>;
}

export interface IQuoteCompareGroupItems {
  description: string;
  values: string;
}


export interface IActiveQuoteAssetTabDetails {
  active: boolean;
  convenienceDetails: IQuoteCompareDetailsConvenienceEssential;
  essentialDetails: IQuoteCompareDetailsConvenienceEssential;
  name: string;
  quoteCompareOne?: Array<IInsuredAsset> | IPersonalLiabilityCompare;
  quoteCompareTwo?: Array<IInsuredAsset> | IPersonalLiabilityCompare;
  type: AssetType ;
  special_conditions?: any;
}

export interface IPersonalLiabilityCompare {
  assistance_benefits?: Array<IAssistanceBenefit>;
  broker_fee?: number;
  personal_liability?: Array<IPersonalLiability>;
}

export interface IQuoteComparisonAssetTab {
  name: string;
  type: AssetType;
  covered_details: Array<IQuoteAssetTabCoveredDetails>;
  benefit_group?: Array<IQuoteAssetTabBenefitGroup>;

  active: boolean;
}
export interface IQuoteAssetTabCoveredDetails {
  cover_text: string;
  offered_on_quote_one: boolean;
  offered_on_quote_two: boolean;
}
export interface IQuoteAssetTabBenefitGroup {
  description: string;
  values: string;
}

export interface IAlertBrokerOfEndorsement {
  asset_type: string;
  schedule_id: string;
  asset_id: string;
}

export interface IQuoteRejectReason {
  code: string;
  description: string;
}

export interface IQuoteReject {
  quote_id: number;
  reason: IQuoteRejectReason;
}
